import { classnames } from '@tools/common'

interface TableIconButtonProps {
  icon: React.ReactNode
  iconClassName?: string
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
  className?: string
  onClick: () => void
}

const TableIconButton = ({
  icon,
  onClick,
  iconClassName,
  disabled,
  type,
  className,
}: TableIconButtonProps) => (
  <button
    type={type}
    disabled={disabled}
    className={classnames(
      'flex items-center justify-center w-[26px] h-[26px] bg-main-100 rounded-lg overflow-hidden',
      {
        'group-hover/row:bg-main-300': !disabled,
      },
      className,
    )}
    onClick={e => {
      e.stopPropagation()
      onClick && onClick()
    }}
  >
    <div
      className={classnames('p-1.5 text-main-900', iconClassName, {
        'hover:bg-main-900 hover:text-white': !disabled,
        'group/icon group-hover/icon:text-white': !disabled,
        'opacity-30 hover:bg-main-100': disabled,
      })}
    >
      {icon}
    </div>
  </button>
)

export default TableIconButton
